import React from 'react';
import { useDataStore } from '../store/dataStore';

// DataProvider is now just a passthrough wrapper
// Since Zustand doesn't need a provider, we just render children.
// This prevents breaking existing code that wraps components with <DataProvider>
export const DataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

// useData is now an alias for useDataStore
export const useData = () => {
  return useDataStore();
};
